var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStylevision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "StyleVision",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3 28.8c0 15.7-12.8 28.5-28.5 28.5S.3 44.5.3 28.8 13.1.3 28.8.3s28.5 12.8 28.5 28.5z",
    fill: "#7cce06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6 23H41c3.5 0 6.4-2.9 6.4-6.5 0-3.5-2.9-6.4-6.4-6.4H25c-6.8 0-12.3 5.5-12.3 12.3 0 5 3 9.3 7.3 11.3h-4.2c-3.6 0-6.4 2.9-6.4 6.4 0 3.6 2.9 6.4 6.4 6.4h17.7c6.8 0 12.3-5.5 12.3-12.3.1-5-2.9-9.3-7.2-11.2z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3 38.6 25.3 16c-.6-1.3-1.9-2.2-3.4-2.2-2.1 0-3.8 1.7-3.8 3.8 0 .6.1 1.2.4 1.7l7.6 17.2H15.8c-2.1 0-3.8 1.7-3.8 3.8 0 2.1 1.7 3.8 3.8 3.8h16.1c2.1 0 3.8-1.7 3.8-3.8 0-.7-.1-1.2-.4-1.7z",
    fill: "#018f1c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStylevision);
export default __webpack_public_path__ + "static/media/stylevision.c2877e2f8e22f7bc886c896a6f44d9ec.svg";
export { ForwardRef as ReactComponent };